// extracted by mini-css-extract-plugin
export var card = "_4t-0";
export var content = "_4t-1";
export var contentLoading = "_4t-2";